(() => {
  if (window.VtDialoog) return;

  let bewaardeHoogte = 0;
  let aantalOpen = 0;

  function vergrendel() {
    aantalOpen += 1;
    if (aantalOpen > 1) return;
    bewaardeHoogte = window.scrollY;
    const s = document.body.style;
    s.position = 'fixed';
    s.top = `-${bewaardeHoogte}px`;
    s.width = '100%';
  }

  function ontgrendel() {
    aantalOpen = Math.max(0, aantalOpen - 1);
    if (aantalOpen > 0) return;
    const s = document.body.style;
    s.position = '';
    s.top = '';
    s.width = '';
    window.scrollTo({ top: bewaardeHoogte, behavior: 'instant' });
  }

  const gekoppeld = new WeakSet();
  const opener = new WeakMap();

  function koppel(dlg) {
    if (gekoppeld.has(dlg)) return;
    gekoppeld.add(dlg);
    dlg.addEventListener('close', () => {
      ontgrendel();
      const o = opener.get(dlg);
      if (o && document.contains(o)) o.focus?.({ preventScroll: true });
    });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  }

  window.VtDialoog = {
    vergrendel,
    ontgrendel,
    open(dlg) {
      if (!dlg || dlg.open) return;
      koppel(dlg);
      opener.set(dlg, document.activeElement);
      vergrendel();
      dlg.showModal();
    },
    sluit(dlg) {
      if (dlg && dlg.open) dlg.close();
    },
  };
})();
